export default __webpack_public_path__ + "static/media/women.31930686.jpg";